import styled from "styled-components/macro";
import { COLORS } from "../../../layout/theme";
import { Button as ButtonAntd } from "antd";

export const Inner = styled.div`
	min-height: 100vh;
	background-color: rgb(243 244 246 / 1);
	padding: 30px 20px;
	gap: 20px;
`;

export const Wrapper = styled.div`
	background-color: ${COLORS.LightGrey};
	padding: 10px;
`;

export const AntdButton = styled(ButtonAntd)`
	background-color: ${(props) =>
		props.$active ? COLORS.Primary : COLORS.White};
	color: ${(props) => (props.$active ? COLORS.White : COLORS.Primary)};
	border-color: ${COLORS.Primary};
	border-radius: 5px;
	${(props) =>
		props.height &&
		`
      height: ${props.height}px;
    `}
	${(props) =>
		props.width &&
		`
      width: ${props.width}px;
    `}
  ${(props) => props.fontSize && `font-size: ${props.fontSize}px`}
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 10px;
`;
